import { createContext } from 'react';

import { IVehicle } from '../../schema/Vehicle.ts';

interface ContextType {
  selectedVehicle: IVehicle | undefined;
  setSelectedVehicle: (selectedVehicle: IVehicle | undefined) => void;
}

const defaultValue: ContextType = {
  selectedVehicle: undefined,
  setSelectedVehicle: () => {},
};

export const SelectedVehicleContext = createContext<ContextType>(defaultValue);
